<template>
	<div>
        <Form class="search-other" :label-width="100" inline ref="form" :model='formData'>
            <FormItem label='客户组织'>
                <Select v-model="formData.organizationId" filterable clearable>
                    <Option v-for="item in orglist" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </FormItem>
            <FormItem label='费用类型' prop='billtype' :rules='required' >
                <Select v-model="formData.billtype" filterable clearable @on-change="changeBillCode(formData.billtype)">
                    <Option v-for="item in billtypelist" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </FormItem>
            <FormItem label='费用类型代码' prop='expenseCategoryCustomizeCode' :rules='required'>
                <Select v-model="formData.expenseCategoryCustomizeCode" filterable clearable placeholder="请先选择费用类型">
                    <Option v-for="item in billtypecodelist" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </FormItem>
            <FormItem :label-width="1">
                <Button type="primary" @click="update" icon="ios-search">搜索</Button>
                <Button class="margin-left-5" @click="reset" icon='md-refresh'>重置</Button>
            </FormItem>
        </Form>
		<Table :columns="columns" :data="dataList" @on-selection-change="checkChange"></Table>
		<div class="text-right margin-top-10">
			<vButton @click="submit" theme="primary">{{$t('global.modal.confirm', { defaultValue: '确定' })}}</vButton>
			<vButton class="margin-left-10" @click="cancel" >{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
		</div>
	</div>
</template>
<script>
import { HttpBillallbilltypeList, HttpBillTypeList, HttpSaveBillorgOne } from "@/service/newbigaccount";
import TableList from "@components/templates/tablelist"
export default {
	props:['orglist','billtypelist'],
	components: {
		TableList,
	},
    data(){
        return {
            formData:{},
            billtypecodelist:[],
            required: [{
				required: true,
				message: "该信息不能为空,请填写"

			}],
            dataList:[],
            checkedId:[],
        }
    },
	methods: {
		async update(){
            let valid = await this.$refs['form'].validate();
			if (!valid) return;
            HttpBillallbilltypeList({
                expenseCategoryCustomizeCode:this.formData.expenseCategoryCustomizeCode,
                organizationId:this.formData.organizationId
            }).then(res=>{
                this.dataList = res.data
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        reset(){
            this.formData = {}
            this.dataList = []
        },
        changeBillCode(val){
            HttpBillTypeList({
                "search[EQ_expenseCategoryType]":val,
                rows:1000,
            }).then(res=>{
                this.billtypecodelist = res.data.content.map(item=>{
                    return {
                        value:item.code,
                        label:item.code+'('+(item.name || '--')+')'
                    }
                })
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
		checkChange(selection, val) {
			console.log(selection)
            this.checkedId = selection.map(item => {
                return item.id
            });
		},
		submit() {
            HttpSaveBillorgOne({
                expenseCategoryCustomizeCode:this.formData.expenseCategoryCustomizeCode,
                orgIds:this.checkedId,
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.cancel();
                this.$emit('on-update')
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
		},
		cancel(){
			this.$emit('on-close')
		},
	},
	computed: {
        columns(){
            return [{
                type: 'selection',
                width: 100,
                align: "center",
                formName: 'id',
                isRadio:true,
            }, {
                title: '客户组织',
                key: 'name'
            }, ]
        } 
    },
}
</script>